import OaccRepository from '@evercall/oacc/infrastructure/repository/OaccRepository';
import createAsyncRequest from '@framework/state/createAsyncRequest';
import { getContainer } from '@framework/di/getContainer';
import { IDialIn } from '@evercall/domain/vo/DialIn';

interface IProps {
  setPhoneList: (payload: Array<IDialIn>) => void,
}

export default ({ setPhoneList }: IProps) => {
  const container = getContainer();
  const oaccRepository: OaccRepository = container.get(OaccRepository);

  const getCountryPhoneList = createAsyncRequest<typeof oaccRepository.getDialInPhones>({
    method: oaccRepository.getDialInPhones,
    callbacks: {
      onSuccess: ({ response }) => setPhoneList(response),
    },
  });

  return {
    getCountryPhoneList,
  };
};
